import { shortenAddress } from '../lib/format.js';
import type { MerchantSummary } from '../lib/api.js';

export interface MerchantCardProps {
  readonly merchant: MerchantSummary;
  readonly onLogout: () => void;
}

export function MerchantCard({ merchant, onLogout }: MerchantCardProps) {
  return (
    <div className="card" aria-label="merchant-card">
      <div className="row">
        <div>
          <div className="muted" style={{ fontSize: 11 }}>MERCHANT</div>
          <div style={{ fontSize: 16, fontWeight: 600 }}>{merchant.name}</div>
          <div className="mono muted" style={{ marginTop: 4 }}>{merchant.merchantId}</div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span className={`pill ${merchant.status === 'active' ? 'ok' : 'warn'}`}>
            {merchant.status}
          </span>
          <button className="btn secondary" onClick={onLogout}>Çıkış</button>
        </div>
      </div>
      <div style={{ marginTop: 16 }}>
        <div className="muted" style={{ fontSize: 11 }}>MASTER WALLETS</div>
        <table style={{ marginTop: 6 }}>
          <thead>
            <tr>
              <th>Chain</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(merchant.masterWallets).map(([chain, addr]) =>
              addr ? (
                <tr key={chain}>
                  <td className="mono">{chain}</td>
                  <td className="mono" title={addr}>{shortenAddress(addr, 6, 6)}</td>
                </tr>
              ) : null,
            )}
          </tbody>
        </table>
      </div>
      {merchant.webhookUrl ? (
        <div style={{ marginTop: 16 }}>
          <div className="muted" style={{ fontSize: 11 }}>WEBHOOK</div>
          <div className="mono">{merchant.webhookUrl}</div>
        </div>
      ) : null}
    </div>
  );
}
